module.exports = __webpack_public_path__ + "img/title-2.0535e207.png";